import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from '@shared/apis';
import { FileService } from '@shared/services/file.service';

@Component({
  selector: 'app-attachment-view',
  templateUrl: './attachment-view.component.html',
  styleUrls: ['./attachment-view.component.scss']
})
export class AttachmentViewComponent implements OnInit, OnDestroy {

  @Input()
  attachmentImage;

  @Input()
  params;
  // set params(value) {
  //   const { ticketInfo, attachment } = value;
  //   this.downloadUrl = this.apiService.ticket.attachmentUrl(ticketInfo, attachment, 'attachment');
  // }

  onClose: Subject<any> = new Subject();
  downloadUrl: any;

  private alive = true;

  constructor(private bsModalRef: BsModalRef,
              private fileService: FileService,
              private apiService: ApiService,) {
  }

  ngOnInit() {
  }

  cancel() {
    this.bsModalRef.hide();
  }

  download() {
    const { ticketInfo, attachment } = this.params;
    this.downloadUrl = this.apiService.ticket.attachmentUrl(ticketInfo, attachment, 'attachment');
    this.fileService.downloadFile(this.downloadUrl, attachment.filename);
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
